// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/DINPro-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/DINPro-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/DINPro-Bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@font-face {
  font-family: "Regular";  
  src: local("DINPro-Regular"),
      url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

@font-face {
  font-family: "Medium";  
  src: local("DINPro-Medium"),
      url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}

@font-face {
  font-family: "Bold";  
  src: local("DINPro-Bold"),
      url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}

.wrapper {
  width: 80%;
  background-color: red;
}

.logoWrapper {
  padding-top: 35;
  display: 'flex';
  align-items: 'center';
  justify-content: 'center';
  margin: 0px 35px;
}

.logoImage {
  width: 250;
  height: 123;
}

.formWrapper {
  margin-top: 52;
  align-items: 'center';
}

.subText {
  margin-top: 8,
}

.SV {
  padding-bottom: 32;
}

.myButton:hover{
  background-color: #6E6B77 !important;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.hide-scroll::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.hide-scroll {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.input {
  height: 44px;
  background-color: #FFFFFF;
  border: 2px solid #E9EBE7;
  border-radius: 8px;
  padding: 0px 20px;
  font-family: 'Regular';
  font-size: 16px;
  color: #282c34;
  margin-top: 8px;
  
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB;gEACwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB;gEACuD;AACzD;;AAEA;EACE,mBAAmB;EACnB;gEACqD;AACvD;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,gDAAgD;AAChD;EACE,aAAa;AACf;;AAEA,4CAA4C;AAC5C;EACE,wBAAwB,GAAG,gBAAgB;EAC3C,qBAAqB,GAAG,YAAY;AACtC;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,eAAe;;AAEjB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@font-face {\n  font-family: \"Regular\";  \n  src: local(\"DINPro-Regular\"),\n      url(\"./fonts/DINPro-Regular.otf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Medium\";  \n  src: local(\"DINPro-Medium\"),\n      url(\"./fonts/DINPro-Medium.otf\") format(\"truetype\");\n}\n\n@font-face {\n  font-family: \"Bold\";  \n  src: local(\"DINPro-Bold\"),\n      url(\"./fonts/DINPro-Bold.otf\") format(\"truetype\");\n}\n\n.wrapper {\n  width: 80%;\n  background-color: red;\n}\n\n.logoWrapper {\n  padding-top: 35;\n  display: 'flex';\n  align-items: 'center';\n  justify-content: 'center';\n  margin: 0px 35px;\n}\n\n.logoImage {\n  width: 250;\n  height: 123;\n}\n\n.formWrapper {\n  margin-top: 52;\n  align-items: 'center';\n}\n\n.subText {\n  margin-top: 8,\n}\n\n.SV {\n  padding-bottom: 32;\n}\n\n.myButton:hover{\n  background-color: #6E6B77 !important;\n}\n\n/* Hide scrollbar for Chrome, Safari and Opera */\n.hide-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.hide-scroll {\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;  /* Firefox */\n}\n\n.input {\n  height: 44px;\n  background-color: #FFFFFF;\n  border: 2px solid #E9EBE7;\n  border-radius: 8px;\n  padding: 0px 20px;\n  font-family: 'Regular';\n  font-size: 16px;\n  color: #282c34;\n  margin-top: 8px;\n  \n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
